// import logo from './logo.svg';
import './css/reset.css';
import './css/toastr.css'
import './App.css';
import NirForm from './components/NirForm';

function App() {
  return (
    <div className="App">
      <NirForm/>
    </div>
  );
}

export default App;
